import { render, staticRenderFns } from "./cabinet-address-list.vue?vue&type=template&id=2b4b6920&"
import script from "./cabinet-address-list.vue?vue&type=script&lang=js&"
export * from "./cabinet-address-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4b6920')) {
      api.createRecord('2b4b6920', component.options)
    } else {
      api.reload('2b4b6920', component.options)
    }
    module.hot.accept("./cabinet-address-list.vue?vue&type=template&id=2b4b6920&", function () {
      api.rerender('2b4b6920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/addresses/cabinet-address-list.vue"
export default component.exports